import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/business")({
  component: lazyRouteComponent(() => import("./+BusinessSettings")),
  head: () => ({
    meta: seo({ title: "Business Settings" }),
  }),
});
